import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2 } from "lucide-react";

const PLAN_FEATURES = {
  Solo: ["25 estimates/mo", "Email follow-ups", "1 user"],
  Crew: ["150 estimates/mo", "Email + SMS", "5 users", "Custom branding"],
  Business: ["Unlimited estimates", "Advanced AI", "Unlimited users", "API access"],
};

export default function Settings() {
  const { user } = useAuth();
  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto">
      <div className="mb-6">
        <p className="text-xs uppercase tracking-widest text-primary mb-1">Account</p>
        <h1 className="font-display text-4xl font-black tracking-tight">Settings</h1>
      </div>

      <div className="bento-card p-5 mb-4">
        <h3 className="font-display text-2xl font-bold mb-3">Business profile</h3>
        <div className="grid md:grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-xs uppercase text-muted-foreground">Email</p>
            <p className="font-medium">{user?.email}</p>
          </div>
          <div>
            <p className="text-xs uppercase text-muted-foreground">Business name</p>
            <p className="font-medium">{user?.business_name || "—"}</p>
          </div>
          <div>
            <p className="text-xs uppercase text-muted-foreground">Primary niche</p>
            <p className="font-medium capitalize">{user?.niche?.replace(/_/g, " ")}</p>
          </div>
          <div>
            <p className="text-xs uppercase text-muted-foreground">Current plan</p>
            <Badge className="mt-1 uppercase">{user?.plan || "free"}</Badge>
          </div>
        </div>
      </div>

      <div className="bento-card p-5 mb-4">
        <h3 className="font-display text-2xl font-bold mb-3">Choose a plan</h3>
        <div className="grid md:grid-cols-3 gap-3">
          {[
            { name: "Solo", price: 49 },
            { name: "Crew", price: 99, best: true },
            { name: "Business", price: 149 },
          ].map((p) => (
            <div key={p.name} className={`border rounded-sm p-4 ${p.best ? "border-primary" : "border-border"}`}>
              <p className="font-display text-xl font-bold">{p.name}</p>
              <p className="font-display text-3xl font-black">${p.price}<span className="text-sm text-muted-foreground font-normal">/mo</span></p>
              <ul className="text-sm space-y-1 my-3">
                {PLAN_FEATURES[p.name].map((f) => (
                  <li key={f} className="flex items-start gap-2"><CheckCircle2 className="w-4 h-4 text-primary mt-0.5" /> {f}</li>
                ))}
              </ul>
              <Button data-testid={`upgrade-${p.name}`} className="w-full h-10 rounded-sm" variant={p.best ? "default" : "outline"}>Upgrade to {p.name}</Button>
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-3">Subscription checkout coming online — contact support to activate for now.</p>
      </div>

      <div className="bento-card p-5">
        <h3 className="font-display text-2xl font-bold mb-3">Integrations</h3>
        <ul className="space-y-2 text-sm">
          <li className="flex justify-between border-b border-border pb-2"><span>Claude Sonnet 4.6 (Vision AI)</span><Badge className="bg-emerald-100 text-emerald-900">Connected</Badge></li>
          <li className="flex justify-between border-b border-border pb-2"><span>Stripe payments</span><Badge className="bg-emerald-100 text-emerald-900">Test mode</Badge></li>
          <li className="flex justify-between border-b border-border pb-2"><span>Resend (Email)</span><Badge className="bg-amber-100 text-amber-900">MOCKED — Add API key</Badge></li>
          <li className="flex justify-between"><span>Twilio (SMS)</span><Badge className="bg-amber-100 text-amber-900">MOCKED — Add API key</Badge></li>
        </ul>
      </div>
    </div>
  );
}
